import * as VueRouter from 'vue-router'
import { registerRouterGuards } from '@/router/guards'
import { routes } from '@/router/routes'

const router = VueRouter.createRouter({
  history: VueRouter.createWebHistory(),
  routes,
})

registerRouterGuards(router)

export default router
